import React from "react";

const Saved = () => {
  return (
    <div className="h-[calc(100vh-120px)] flex justify-center items-center">
      <h1 className="relative  bottom-10 text-5xl">coming soon</h1>
    </div>
  );
};

export default Saved;
